import Phaser from "phaser";
import _BaseBall from "./_baseBall";

export default class BallDefault extends _BaseBall {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);

    this.setName('ball-default');
  }
}